'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _defineProperty4 = require('babel-runtime/core-js/object/define-property');

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _immutableOps = require('immutable-ops');

var _constants = require('./constants');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Session = function () {
    function Session(schema, db, state, withMutations, batchToken) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, Session);

        this.schema = schema;
        this.db = db;
        this.state = state || db.getEmptyState();
        this.initialState = this.state;

        this.withMutations = !!withMutations;
        this.batchToken = batchToken || (0, _immutableOps.getBatchToken)();

        this.modelData = {};

        this.models = schema.getModelClasses();

        this.sessionBoundModels = this.models.map(function (modelClass) {
            var sessionBoundModel = function (_modelClass) {
                (0, _inherits3.default)(SessionBoundModel, _modelClass);

                function SessionBoundModel() {
                    (0, _classCallCheck3.default)(this, SessionBoundModel);
                    return (0, _possibleConstructorReturn3.default)(this, _modelClass.apply(this, arguments));
                }

                return SessionBoundModel;
            }(modelClass);
            (0, _defineProperty5.default)(_this2, modelClass.modelName, {
                get: function get() {
                    return sessionBoundModel;
                }
            });

            sessionBoundModel.connect(_this2);
            return sessionBoundModel;
        });
    }

    Session.prototype.getDataForModel = function getDataForModel(modelName) {
        if (!this.modelData[modelName]) {
            this.modelData[modelName] = {};
        }
        return this.modelData[modelName];
    };

    Session.prototype.markAccessed = function markAccessed(modelName) {
        var modelIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var data = this.getDataForModel(modelName);
        if (!data.accessedInstances) {
            data.accessedInstances = {};
        }
        modelIds.forEach(function (id) {
            data.accessedInstances[id] = true;
        });
    };

    Session.prototype.markFullTableScanned = function markFullTableScanned(modelName) {
        var data = this.getDataForModel(modelName);
        data.fullTableScanned = true;
    };

    Session.prototype.applyUpdate = function applyUpdate(updateSpec) {
        var tx = this._getTransaction(updateSpec);
        var result = this.db.update(updateSpec, tx, this.state);
        var status = result.status,
            state = result.state,
            payload = result.payload;


        if (status !== _constants.SUCCESS) {
            throw new Error('Applying update failed: ' + result.toString());
        }

        this.state = state;

        return payload;
    };

    Session.prototype.query = function query(querySpec) {
        var result = this.db.query(querySpec, this.state);

        this._markAccessedByQuery(querySpec, result);

        return result;
    };

    Session.prototype._getTransaction = function _getTransaction(updateSpec) {
        var withMutations = this.withMutations;
        var action = updateSpec.action;
        var batchToken = this.batchToken;

        if ([_constants.UPDATE, _constants.DELETE].includes(action)) {
            batchToken = (0, _immutableOps.getBatchToken)();
        }
        return { batchToken: batchToken, withMutations: withMutations };
    };

    Session.prototype._markAccessedByQuery = function _markAccessedByQuery(querySpec, result) {
        var table = querySpec.table,
            clauses = querySpec.clauses;
        var rows = result.rows;
        var idAttribute = this[table].idAttribute;

        var accessedIds = new _set2.default(rows.map(function (row) {
            return row[idAttribute];
        }));

        var anyClauseFilteredById = clauses.some(function (clause) {
            if (!(0, _utils.clauseFiltersByAttribute)(clause, idAttribute)) {
                return false;
            }

            var id = clause.payload[idAttribute];
            accessedIds.add(id);
            return true;
        });

        if (anyClauseFilteredById) {
            this.markAccessed(table, accessedIds);
        } else {
            this.markFullTableScanned(table);
        }
    };

    Session.prototype.getNextState = function getNextState() {
        (0, _utils.warnDeprecated)('Session.prototype.getNextState function is deprecated. Access ' + 'the Session.prototype.state property instead.');
        return this.state;
    };

    Session.prototype.reduce = function reduce() {
        throw new Error('Session.prototype.reduce is removed. The Redux integration API ' + 'is now decoupled from ORM and Session - see the 0.9 migration guide ' + 'in the GitHub repo.');
    };

    (0, _createClass3.default)(Session, [{
        key: 'accessedModelInstances',
        get: function get() {
            var _this3 = this;

            return this.sessionBoundModels.filter(function (_ref) {
                var modelName = _ref.modelName;
                return !!_this3.getDataForModel(modelName).accessedInstances;
            }).reduce(function (result, _ref2) {
                var modelName = _ref2.modelName;
                return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, modelName, _this3.getDataForModel(modelName).accessedInstances));
            }, {});
        }
    }, {
        key: 'fullTableScannedModels',
        get: function get() {
            var _this4 = this;

            return this.sessionBoundModels.filter(function (_ref3) {
                var modelName = _ref3.modelName;
                return !!_this4.getDataForModel(modelName).fullTableScanned;
            }).map(function (_ref4) {
                var modelName = _ref4.modelName;
                return modelName;
            });
        }
    }]);
    return Session;
}();

exports.default = Session;